import { render, staticRenderFns } from "./PrePostDC.vue?vue&type=template&id=1306ea33"
import script from "./PrePostDC.vue?vue&type=script&lang=js"
export * from "./PrePostDC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports